import { render } from "./BookIcon.vue?vue&type=template&id=696ab0e9"
import script from "./BookIcon.vue?vue&type=script&lang=js"
export * from "./BookIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__